import { PropsWithChildren } from 'react';
import SectionBody from '../components/SectionBody';
import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

export default function Schedule() {
  return (
    <SectionContainer containerId={'schedule'}>
      <SectionTitle title={'schedule'} />
      <SectionBody>
        <ScheduleBlockContainer beforeSup={'Friday, September 19'}>
          <ScheduleDetail
            title={'Welcome Gathering'}
            timeStr={'6:30 PM - 8:00 PM'}
            items={[
              'Cash bar',
              'Snacks and sweets',
              'Live music by Takoda Dionne!',
            ]}
            location={'Footbridge Brewery - Boothbay Harbor, ME'}
            locationUrl={'https://maps.app.goo.gl/x8fidBQyeGegXdUc7'}
          />
        </ScheduleBlockContainer>

        <ScheduleBlockContainer beforeSup={'Saturday, September 20'}>
          <ScheduleDetail
            title={'Wedding Ceremony'}
            timeStr={'4:00 PM - 5:00 PM'}
            items={[
              '4:00 PM - Arrive for wedding ceremony',
              '4:30 PM - Ceremony start time',
            ]}
            location={'The Shipyard - Boothbay Harbor, ME'}
            locationUrl={'https://maps.app.goo.gl/3ET5EZtzN7Fx46hv6'}
          />
          <ScheduleDetail
            title={'Cocktail Hour'}
            timeStr={'5:00 PM - 6:00 PM'}
            items={["Some of Loren and Robbie's favorite cocktails"]}
            location={'The Shipyard - Boothbay Harbor, ME'}
            locationUrl={'https://maps.app.goo.gl/3ET5EZtzN7Fx46hv6'}
          />
          <ScheduleDetail
            title={'Reception Dinner'}
            timeStr={'6:00 PM - 7:00 PM'}
            items={['Risotto bar', 'Charcuterie', 'Beer and wine']}
            location={'The Shipyard - Boothbay Harbor, ME'}
            locationUrl={'https://maps.app.goo.gl/3ET5EZtzN7Fx46hv6'}
          />
          <ScheduleDetail
            title={'Music and Dancing'}
            timeStr={'7:00 PM - 10:00 PM'}
            items={[]}
            location={'The Shipyard - Boothbay Harbor, ME'}
            locationUrl={'https://maps.app.goo.gl/3ET5EZtzN7Fx46hv6'}
          />
          <ScheduleDetail
            title={'Afterparty @ Mine Oyster'}
            timeStr={'10:00 PM - 1:00 AM'}
            items={['Bar and pub nearby the wedding venue']}
            location={'Mine Oyster - Boothbay Harbor, ME'}
            locationUrl={'https://maps.app.goo.gl/2mv8PCg3pcshCkRr8'}
          />
        </ScheduleBlockContainer>
      </SectionBody>
    </SectionContainer>
  );
}

function ScheduleBlockContainer({
  beforeSup,
  children,
}: { beforeSup: string } & PropsWithChildren) {
  return (
    <div className='w-full flex flex-col p-4 bg-white shadow-sm rounded-md border gap-4 section-text'>
      <p className='text-sm font-semibold uppercase tracking-widest text-blue-400'>
        {beforeSup}
        <sup>th</sup>
      </p>
      {children}
    </div>
  );
}

function ScheduleDetail({
  title,
  timeStr,
  location,
  locationUrl,
  items,
}: {
  title: string;
  timeStr: string;
  location: string;
  locationUrl: string;
  items: string[];
}) {
  return (
    <div className='flex flex-col gap-1'>
      <div className='flex flex-row w-full justify-between'>
        <p className='text-sm uppercase tracking-widest'>{title}</p>
        <p className='text-sm uppercase tracking-wide'>{timeStr}</p>
      </div>
      <a
        href={locationUrl}
        target={'_blank'}
        rel={'noreferrer'}
        className='text-sm italic tracking-wide text-blue-400 hover:underline w-min text-nowrap'
      >
        {location}
      </a>
      {items.length > 0 && (
        <ul className='text-sm list-disc ml-4 gap-1'>
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
